<template>

  <b-container fluid class="intro-section">

    <b-col class="h-100 d-flex flex-column px-0">

      <b-row class="py-5 intro-banner text-center">

        <h1>SampleRoulette</h1>

        <h2 class="mt-3 mb-5">Randomly find obscure and (hopefully) sampleable tracks from thousands of YouTube
          videos!</h2>

        <router-link to="/dig">
          <b-button class="mx-auto" style="max-width:200px">Start Digging!
            <b-icon icon="arrow-right-circle-fill" class="ml-2 mt-1"></b-icon>
          </b-button>
        </router-link>

      </b-row>

      <b-container class="pt-4 text-center">
        <b-col class="d-flex flex-col intro-content">
          <b-row style="min-height:1px">

            <b-row class="px-3" data-aos="fade-up" data-aos-delay="0">

              <h2>E-Digging Made Easy</h2>
              <p>SampleRoulette features tens of thousands of curated YouTube videos featuring vinyl rips and recordings
                of old and obscure music, perfect for sampling. Stop spending hours searching for inspiration and make
                the process easy and enjoyable.</p>
            </b-row>

            <b-row class="px-3 mt-5" data-aos="fade-up" data-aos-delay="200">

              <h2 class="mt-2">How Does it Work?</h2>
              <p>With each sample, a video is randomly selected from our massive catalog and starts playing at a random
                time, guaranteeing endless hours of new discovery.</p>
            </b-row>

            <b-row class="px-3 mt-5" data-aos="fade-up" data-aos-delay="300">

              <h2 class="mt-2">Is This Music Copyrighted?</h2>
              <p>Almost certainly, yes! SampleRoulette owns none of the rights to the music provided here. It is sourced
                from music uploads on YouTube. Sampling this music without permission is a violation of the original
                copyright and should not be done without prior clearance. Open the original YouTube video to
                see more information on the original recording.
              </p>

            </b-row>

            <b-row class="px-5 mt-4 pb-4 flex-fill" data-aos="fade-up" data-aos-delay="400">

              <router-link to="/dig">
                <b-button class="mx-auto my-auto" style="max-width:200px">Find a Sample!
                  <b-icon icon="music-note-beamed" class="ml-2 mt-1"></b-icon>
                </b-button>
              </router-link>

            </b-row>

          </b-row>
        </b-col>
      </b-container>

    </b-col>
  </b-container>

</template>

<script>

export default {
  name: "Home"
};

</script>

<style>
.intro-section {
  color: white;
  margin-top: 66px;
  min-height: calc(100vh - 134px);
  width: calc(100vw);
  background: rgb(10, 10, 10);
}

.intro-banner {
  color: rgba(255, 255, 255);
  background-position: center;
  background-size: cover;
  background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url("~@/assets/banner.jpg");
}

.intro-banner h1,
.intro-banner h2 {
  opacity: .9;
}

.intro-content p {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: large;
}
</style>
